import {
  LevelGranulometry,
  LevelGranulometryFullFilled,
  SectionInLevelGranulometryFullFilledContent
} from '../../LevelGranulometry';

export const getLevelFullFilledContent = (
  levelGranulometry: LevelGranulometry | LevelGranulometryFullFilled
): SectionInLevelGranulometryFullFilledContent[] => levelGranulometry.content || [];
